// Sample/Muster Cart Validation - Button-basiert
(function() {
  const MAX_SAMPLE_VARIANTS = 5;
  const MAX_QTY_PER_SAMPLE = 1;
  const SAMPLE_KEYWORD = 'muster';

  console.log('=== SAMPLE VALIDATION LOADED ===');

  function isSampleVariant(text) {
    return text && text.toLowerCase().includes(SAMPLE_KEYWORD);
  }

  function getVariantTitle(variantId) {
    if (window.product && window.product.variants) {
      const variant = window.product.variants.find(function(v) {
        return v.id == variantId;
      });
      if (variant) {
        return variant.name || variant.title || variant.option1 || '';
      }
    }
    return '';
  }

  function getSampleVariantsInCart() {
    return fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        const samples = cart.items.filter(function(item) {
          const title = item.variant_title || item.product_title || item.title || '';
          return isSampleVariant(title);
        });
        console.log('Muster im Warenkorb:', samples.length, 'von max', MAX_SAMPLE_VARIANTS);
        return {
          uniqueCount: samples.length,
          items: samples
        };
      });
  }

  function validateSampleAddition(variantId, quantity, variantTitle) {
    return getSampleVariantsInCart().then(function(result) {
      const uniqueCount = result.uniqueCount;
      const items = result.items;
      
      if (!isSampleVariant(variantTitle)) {
        console.log('Kein Muster - erlaubt');
        return { allowed: true };
      }

      console.log('>>> MUSTER VALIDIERUNG <<<');
      console.log('Bereits im Warenkorb:', uniqueCount);
      console.log('Versuche hinzuzufügen:', variantTitle);

      const existingItem = items.find(function(item) {
        return item.variant_id == variantId;
      });
      
      if (existingItem) {
        console.log('✗ Bereits im Warenkorb!');
        return {
          allowed: false,
          message: 'Dieses Muster befindet sich bereits in Ihrem Warenkorb. Sie können nur 1 Stück pro Muster bestellen.'
        };
      }

      if (uniqueCount >= MAX_SAMPLE_VARIANTS) {
        console.log('✗ Maximum erreicht!');
        return {
          allowed: false,
          message: 'Sie können maximal ' + MAX_SAMPLE_VARIANTS + ' verschiedene Muster bestellen. Bitte entfernen Sie zuerst ein Muster aus dem Warenkorb.'
        };
      }

      if (quantity > MAX_QTY_PER_SAMPLE) {
        console.log('✗ Menge zu hoch!');
        return {
          allowed: false,
          message: 'Sie können nur ' + MAX_QTY_PER_SAMPLE + ' Stück pro Muster bestellen.'
        };
      }

      console.log('✓ Validierung OK');
      return { allowed: true };
    });
  }

  function restrictSampleQuantityInputs() {
    const variantSelectors = document.querySelectorAll('[name="id"], select[id*="variant"], select.product-form__input');
    
    variantSelectors.forEach(function(selector) {
      selector.addEventListener('change', function() {
        const variantId = this.value;
        const variantTitle = getVariantTitle(variantId);
        
        const container = this.closest('form, .product-form, [data-product-form], .product');
        
        if (container) {
          const qtyInput = container.querySelector('input[name="quantity"], input[type="number"]');
          
          if (qtyInput && isSampleVariant(variantTitle)) {
            qtyInput.setAttribute('max', '1');
            if (parseInt(qtyInput.value) > MAX_QTY_PER_SAMPLE) {
              qtyInput.value = MAX_QTY_PER_SAMPLE;
            }
            
            let hint = container.querySelector('.sample-hint');
            if (!hint) {
              hint = document.createElement('div');
              hint.className = 'sample-hint';
              hint.style.cssText = 'color: #d97706; font-size: 0.875rem; margin-top: 0.5rem; font-weight: 500;';
              hint.textContent = '🔸 Muster: Maximal 1 Stück pro Variante';
              qtyInput.parentNode.appendChild(hint);
            }
          } else if (qtyInput) {
            qtyInput.removeAttribute('max');
            const hint = container.querySelector('.sample-hint');
            if (hint) hint.remove();
          }
        }
      });
      
      if (selector.value) {
        selector.dispatchEvent(new Event('change'));
      }
    });

    document.addEventListener('input', function(e) {
      if (e.target.matches('input[name="quantity"], input[type="number"]')) {
        const container = e.target.closest('form, .product-form, [data-product-form], .product');
        if (container) {
          const variantSelector = container.querySelector('[name="id"]');
          if (variantSelector && variantSelector.value) {
            const variantTitle = getVariantTitle(variantSelector.value);
            
            if (isSampleVariant(variantTitle) && parseInt(e.target.value) > MAX_QTY_PER_SAMPLE) {
              e.target.value = MAX_QTY_PER_SAMPLE;
            }
          }
        }
      }
    });
  }

  function restrictCartQuantities() {
    const cartItems = document.querySelectorAll('.cart-item, [data-cart-item], tr[data-line-item-key], .cart__row');
    
    cartItems.forEach(function(item) {
      const allText = item.textContent || item.innerText || '';
      const isMuster = allText.toLowerCase().includes('muster');
      
      if (isMuster) {
        const qtyInput = item.querySelector('input[name*="quantity"], input[name*="updates"], input[type="number"], input.quantity__input, .cart-item__quantity input, quantity-input input');
        
        if (qtyInput) {
          qtyInput.value = '1';
          qtyInput.setAttribute('max', '1');
          qtyInput.setAttribute('readonly', 'readonly');
          qtyInput.style.pointerEvents = 'none';
          qtyInput.style.opacity = '0.6';
          qtyInput.style.backgroundColor = '#f3f4f6';
          
          const buttons = item.querySelectorAll('button, .quantity__button');
          buttons.forEach(function(btn) {
            const btnText = btn.textContent || btn.getAttribute('name') || '';
            if (btnText.includes('plus') || btnText.includes('+') || btn.name === 'plus') {
              btn.style.display = 'none';
            }
          });
          
          qtyInput.addEventListener('input', function(e) {
            e.preventDefault();
            e.target.value = 1;
            return false;
          });
        }
      }
    });
  }

  // Überwache ALLE Button-Klicks
  function interceptAddToCart() {
    document.addEventListener('click', function(e) {
      const button = e.target.closest('button[type="submit"], button[name="add"], .product-form__submit, button:has-text("Muster Bestellen")');
      
      if (button) {
        const form = button.closest('form, .product-form, [data-product-form]');
        
        if (form) {
          const action = form.getAttribute('action') || '';
          
          // Nur bei cart/add Forms
          if (action.includes('/cart/add') || button.textContent.includes('Bestellen') || button.textContent.includes('Warenkorb')) {
            console.log('>>> Button-Klick erkannt!');
            
            const variantInput = form.querySelector('[name="id"]');
            const qtyInput = form.querySelector('[name="quantity"]');
            
            if (variantInput) {
              const variantId = parseInt(variantInput.value);
              const quantity = qtyInput ? parseInt(qtyInput.value) : 1;
              const variantTitle = getVariantTitle(variantId);
              
              console.log('Variant ID:', variantId, 'Titel:', variantTitle, 'Menge:', quantity);
              
              if (isSampleVariant(variantTitle)) {
                console.log('>>> MUSTER ERKANNT - VALIDIERE <<<');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                validateSampleAddition(variantId, quantity, variantTitle).then(function(result) {
                  if (result.allowed) {
                    console.log('✓ Erlaubt - füge hinzu');
                    // Trigger original submit
                    button.click();
                  } else {
                    console.log('✗ Blockiert:', result.message);
                    alert(result.message);
                  }
                });
                
                return false;
              }
            }
          }
        }
      }
    }, true); // true = capture phase
  }

  document.addEventListener('DOMContentLoaded', function() {
    console.log('Sample Validation geladen');
    restrictSampleQuantityInputs();
    interceptAddToCart();
    
    if (window.location.pathname.includes('/cart')) {
      setTimeout(restrictCartQuantities, 500);
      
      const observer = new MutationObserver(function() {
        restrictCartQuantities();
      });
      
      const cartContainer = document.querySelector('.cart, [data-cart], main, #main-cart');
      if (cartContainer) {
        observer.observe(cartContainer, { childList: true, subtree: true });
      }
    }
  });

})();
